import { FlowComponentHeader } from "@/components/ui/flow-component-header";

type VisualizationContainerProps = {
  config: {
    style?: string;
    title?: string;
    description?: string;
  };
  children: React.ReactNode;
};

export function VisualizationContainer({ config, children }: VisualizationContainerProps) {
  const containerClass =
    config.style === "border"
      ? "border rounded-lg p-6 space-y-4"
      : config.style === "box"
        ? "rounded-lg p-6 space-y-4 bg-muted/50"
        : "space-y-4";

  return (
    <div className={`w-full ${containerClass}`}>
      <FlowComponentHeader title={config.title} description={config.description} />
      {children}
    </div>
  );
}
